import { SERVICES_TYPE } from 'src/globals/enumerations'

export const getServicesStoplistOwnDeliveryItems = state =>
  state.servicesStoplist?.servicesStoplist?.filter(stoplistItem => stoplistItem.type === SERVICES_TYPE.DELIVERY_OWN)

export const getServicesStopList = state => state.servicesStoplist?.servicesStoplist
